import { Box, Button } from "@mui/material";
import {
  DataGridPremium,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-premium";
import { useDispatch } from "react-redux";
import { setFormOpen, setSelectedFormID } from "../../reducers/rhapsody";
import Id from "../id/id";
import { useForms } from "src/redux/form/formHooks";
import { useNavigate } from "react-router-dom";

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

const getOrganizationIDs = (config?: string) => {
  if (!config) return "";
  try {
    const parsed = JSON.parse(config);
    return parsed?.organizationIDs ?? "";
  } catch (_e) {
    return "";
  }
};

/**
 * Family
 *
 * @returns {null} Family
 */
export default function Forms() {
  const { forms } = useForms();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const openForm = (id: number) => {
    dispatch(setSelectedFormID(id));
    dispatch(setFormOpen({ isOpen: true, formID: "form" }));
  };

  return (
    <DataGridPremium
      rows={forms ?? []}
      density="compact"
      columns={[
        {
          field: "id",
          headerName: "ID",
          type: "number",
          width: 60,
          renderCell: (p) => {
            if (p.id === -1) return <Box />;
            return (
              <Id
                startDecorator={<i className="fa-regular fa-layer-group"></i>}
              >
                {p.id}
              </Id>
            );
          },
        },
        { field: "name", headerName: "Name", flex: 1 },
        { field: "code", headerName: "Code", flex: 1 },
        { field: "type", headerName: "Type", flex: 1 },
        {
          field: "organizationIDs",
          headerName: "Organization IDs",
          flex: 1,
          valueGetter: (params) => getOrganizationIDs(params.row?.config),
        },
        {
          field: "actions",
          headerName: "Actions",
          sortable: false,
          filterable: false,
          width: 200,
          renderCell: (params) => (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                size="small"
                variant="outlined"
                onClick={(event) => {
                  event.stopPropagation(); // keep row click from navigating
                  openForm(params.row.id);
                }}
              >
                Edit
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={(event) => {
                  event.stopPropagation();
                  navigate(`/forms/${params.row.id}`);
                }}
              >
                Open
              </Button>
            </Box>
          ),
        },
      ]}
      slots={{ toolbar: QuickSearchToolbar }}
      onRowDoubleClick={(e) => {
        openForm(e.row.id);
      }}
      onRowClick={(e) => {
        navigate(`/forms/${e.row.id}`);
        dispatch(setSelectedFormID(e.row.id));
        // dispatch(setFormOpen({ isOpen: true, formID: "form" }));
      }}
    />
  );
}

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
        display: "flex",
      }}
    >
      <GridToolbarQuickFilter
        variant="outlined"
        size="small"
        sx={{ flex: 1 }}
        fullWidth
      />
    </Box>
  );
}
